import React from "react";
import { Link } from "react-router";
import { Navigation } from "../components/Navigation";
import classnames from "classnames";

import Logo from "../assets/images/logo/catalog_logo.svg";

import "./Header.css";

const LogoContainer = ({ pinned, transparent }) => {
  const className = classnames({
    logo: true,
    logoPinned: pinned,
    logoTransparent: transparent
  });

  return (
    <div className={className}>
      <img src={Logo} className="logoIcon" alt="Catalog Logo" />
    </div>
  );
};

export const Header = ({ pinned, transparent }) => {
  const className = classnames({
    header: true,
    headerPinned: pinned,
    headerTransparent: transparent
  });

  return (
    <header className={className}>
      <div className="headerInner">
        <div className="headerLeft">
          <Link to="/" className="brandmark">
            <LogoContainer pinned={pinned} transparent={transparent} />
          </Link>
        </div>
        <div className="headerRight">
          <Navigation pinned={pinned} transparent={transparent} />
        </div>
      </div>
    </header>
  );
};



// WEBPACK FOOTER //
// ./src/components/Header.js